		$(function(){
			var screenWidth = $(window).width();
			if(screenWidth>780){
				$('.scrollPicList li').each(function(index){
					var childNode = $(this).find('.elementConts');
					var listLength = $('.scrollPicList li').length;
					if(index+1==listLength){
						
					}else
			
					ScrollTrigger.create({
						trigger: childNode,
						start: 'top top',
						end:'+=1000',
						scrub: true,
						animation:
						gsap.timeline()
						.fromTo(childNode, {scale:1}, {scale:0.95})
					})
				})
				
			}else{
				$('.scrollPicList li').each(function(index){
					var childNode = $(this).find('.elementConts');
					var listLength = $('.scrollPicList li').length;
					if(index+1==listLength){
						
					}else	
					ScrollTrigger.create({
						trigger: childNode,
						start: 'top top',
						end:'+=1000',
						scrub: true,
						animation:
						gsap.timeline()
						.fromTo(childNode, {scale:1}, {scale:0.9})
					})
				})
			}
		})
		
